import { STEP_FOR_SLICE } from "../../../../shared/config";
export var prepareQuickReplies = function prepareQuickReplies(_ref) {
  var items = _ref.items,
    slice = _ref.slice;
  var flexList = [];
  var fixedList = [];
  items.forEach(function (item) {
    if (item.fixedButton) {
      fixedList.push(item);
    } else {
      flexList.push(item);
    }
  });
  var isMoreVariant = flexList.length > STEP_FOR_SLICE;
  var flexListByPage = isMoreVariant ? flexList.slice(slice, slice + 5) : flexList;
  return {
    flexListByPage: flexListByPage,
    lengthFlexList: flexList.length,
    fixedList: fixedList,
    isMoreVariant: isMoreVariant
  };
};